var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreviousBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(8 12) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9429",
    d: "M2.917,291.965a.883.883,0,0,0-.847.556.836.836,0,0,0,.266.956l5.4,4.474-5.4,4.472a.84.84,0,0,0-.349.824.863.863,0,0,0,.6.676.9.9,0,0,0,.9-.208L9.666,298.6a.835.835,0,0,0,0-1.3L3.482,292.18a.9.9,0,0,0-.565-.215Z",
    transform: "translate(-1.976 -291.965)",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousBtn);
export default __webpack_public_path__ + "static/media/previousBtn.cfac9e5977ba713d48b240819d8669c7.svg";
export { ForwardRef as ReactComponent };